import React from 'react';
import { HelpTooltip } from './HelpTooltip';
import { wt } from './widgetTokens';

interface TextareaWidgetProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  error?: string;
  disabled?: boolean;
  required?: boolean;
  description?: string;
  placeholder?: string;
  rows?: number;
  helpText?: string;
}

export const TextareaWidget: React.FC<TextareaWidgetProps> = ({
  label,
  value,
  onChange,
  error,
  disabled = false,
  required = false,
  description,
  placeholder,
  rows = 4,
  helpText
}) => {
  return (
    <div className={wt.container}>
      <div className={wt.labelRow}>
        <label className={wt.label}>
          {label}
          {required && <span className={wt.required}>*</span>}
        </label>
        {helpText && <HelpTooltip helpText={helpText} />}
      </div>
      {description && <p className={wt.description}>{description}</p>}
      <textarea
        value={value || ''}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled}
        placeholder={placeholder}
        rows={rows}
        className={`${wt.textarea} ${error ? wt.inputError : ''}`}
      />
      {error && <p className={wt.errorMsg}>{error}</p>}
    </div>
  );
};

export default TextareaWidget;
